import React from 'react';
import { Tag } from 'antd';

const StockBadge = ({ qty, threshold = 10 }) => {
  const numericQty = Number(qty) || 0;

  if (numericQty > threshold) {
    return <Tag color="success">Good</Tag>;
  } else if (numericQty > 0) {
    return <Tag color="warning">Low</Tag>;
  } else {
    return <Tag color="error">Critical</Tag>;
  }
};

export default StockBadge;